import type { SVGProps } from "react";
export interface PingpongIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function PingpongIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: PingpongIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M6.29 6.29a1.125 1.125 0 0 1 1.506-.077l.085.077 9.83 9.83.075.084a1.125 1.125 0 0 1-1.582 1.582l-.085-.076L6.29 7.881l-.077-.085A1.125 1.125 0 0 1 6.29 6.29"
      />
      <path
        fill={color}
        d="M8.315 3.657C11.613.624 17.082-.496 20.791 3.2l.02.02.01.012c3.669 3.708 2.549 9.16-.477 12.451l-.3.313c-2.33 2.332-5.322 3.25-8.04 2.904l-.541-.086c-1.275-.245-2.382-.007-2.949.653L6.298 22.05a3.085 3.085 0 0 1-4.273.396l-.248-.223a3.083 3.083 0 0 1 .173-4.519l2.583-2.216.118-.113c.57-.593.763-1.642.534-2.838-.548-2.857.33-6.094 2.818-8.58zm11.902 14.23a2.126 2.126 0 1 1-2.33 2.33L17.874 20l.011-.217A2.125 2.125 0 0 1 20 17.874l.217.012ZM19.207 4.8c-2.645-2.645-6.895-1.97-9.613.747-1.972 1.97-2.603 4.458-2.199 6.565.288 1.502.181 3.474-1.12 4.82l-.277.26-2.583 2.217a.834.834 0 0 0-.045 1.221l.137.112a.83.83 0 0 0 1.083-.159l2.216-2.582.261-.277c1.346-1.302 3.32-1.407 4.82-1.12l.4.064c2.016.256 4.318-.414 6.166-2.263 2.712-2.714 3.388-6.954.759-9.6l-.004-.005Z"
      />
    </svg>
  );
}
